import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeSalesOrderUpdate } from './serialize';

/**
 * PATCH `/crm/sales-order/{id}`。僅 DRAFT 主內容／lines；含 updatedAt（record）。
 * 送出 `lines` 時為 full replacement。PREPARING 配置請走 `updateSalesOrderLine`。
 */
export async function updateSalesOrder(id, payload) {
  const { data: raw } = await request.patch(
    `/crm/sales-order/${id}`,
    serializeSalesOrderUpdate(payload),
  );
  return parseVer4DetailResponse(raw);
}
